export default __webpack_public_path__ + "assets/pdf/FT_VC38.117d2258.pdf";